import { createApp } from "vue";
import { createPinia } from "pinia";
import router from "./router";
import App from "./App.vue";
import { reveal } from "./directives/reveal";
import { initInteractions } from "./directives/interactions";
import "./assets/theme.css";

const app = createApp(App);
app.use(createPinia()).use(router);
// 全局注册入场动画指令，任意容器加 v-reveal 即可让子元素逐个展开
app.directive("reveal", reveal);
app.mount("#app");

// 启动全局交互增强：光标光晕、按钮涟漪、卡片磁吸高光
initInteractions();
